<div class="typewriter">
    <h1>404  Ups! No esperábamos ésto  :'(</h1>
</div>